// src/HomePage/Game/DailyReward/DailyReward.js
import React, { useState, useEffect } from 'react';
import {
  fetchStudentInfoFirestore,
  updateDailyRewardFirestore,
  addRewardStarsOnly, // Hàm cộng sao không ghi log Firestore
} from '../../../FirebaseService';

const DailyReward = ({
  studentInfo,
  setStudentInfo,
  studentId,
  setStudentId,
  isCatechist,
  hasDailyToday,
  quizAttempts,
  loadRewards,
  onGoToQuiz
}) => {
  const [rewardMessage, setRewardMessage] = useState('');
  const [error, setError] = useState('');
  const [inputId, setInputId] = useState(studentId || '');
  const [adAttempts, setAdAttempts] = useState(0);

  const activeId = isCatechist
    ? (localStorage.getItem('uid') || studentId)
    : (localStorage.getItem('studentId') || studentId);

  // Lấy ngày hiện tại theo dạng YYYY-MM-DD để làm mốc reset mỗi ngày
  const getTodayDateStr = () => new Date().toLocaleDateString('sv-SE');

  // Đọc số lần đã xem trong ngày từ trình duyệt (localStorage)
  const getDailyAdAttemptsFromBrowser = (userId) => {
    if (!userId) return 0;
    const key = `ad_views_${userId}_${getTodayDateStr()}`;
    const saved = localStorage.getItem(key);
    return saved ? parseInt(saved, 10) : 0;
  };

  // Cập nhật số lần xem vào trình duyệt
  const saveDailyAdAttemptsToBrowser = (userId, count) => {
    if (!userId) return;
    const key = `ad_views_${userId}_${getTodayDateStr()}`;
    localStorage.setItem(key, count.toString());
  };

  // Tự động kiểm tra số lượt xem của tài khoản hiện tại khi vào màn hình
  useEffect(() => {
    if (activeId) {
      setAdAttempts(getDailyAdAttemptsFromBrowser(activeId));
    }
  }, [activeId, studentInfo]);

  const handleInputChange = (e) => {
    setInputId(e.target.value.toUpperCase());
  };

  const handleIdSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setRewardMessage('');

    const cleanId = inputId.trim().toUpperCase();
    if (!cleanId) {
      setError('Vui lòng nhập mã ID của bạn!');
      return;
    }

    try {
      const info = await fetchStudentInfoFirestore(cleanId);
      if (info.error) {
        setError(info.error);
        return;
      }

      setStudentInfo({ ...info, isCatechist: false });
      setStudentId(cleanId);
      localStorage.setItem('studentId', cleanId);
      localStorage.setItem('studentHolyName', info.holyName);
      localStorage.setItem('studentFullName', info.fullName);

      await loadRewards(cleanId, false);
      setAdAttempts(getDailyAdAttemptsFromBrowser(cleanId));
    } catch (err) {
      setError('Có lỗi xảy ra trong quá trình đăng nhập. Vui lòng thử lại!');
    }
  };

  const handleDailyReward = async () => {
    setRewardMessage('');
    if (!activeId) {
      setRewardMessage('Không tìm thấy thông tin tài khoản.');
      return;
    }

    const rewardResult = await updateDailyRewardFirestore(activeId, isCatechist);
    if (rewardResult.success) {
      setRewardMessage('🎉 Chúc mừng! Bạn đã nhận thành công 1 ngôi sao hôm nay.');
      loadRewards(activeId, isCatechist);
    } else {
      setRewardMessage(rewardResult.message || 'Bạn đã nhận thưởng hàng ngày hôm nay rồi.');
    }
  };

  return (
    <div className="daily-reward-container">
      {!studentInfo ? (
        <div className="lgfun-login-box">
          <div className="lgfun-login-icon">🔑</div>
          <h3>Đăng Nhập Mã Thiếu Nhi</h3>
          <p>Nhập mã ID cá nhân của em để tham gia tích sao nhé!</p>

          <form onSubmit={handleIdSubmit} className="lgfun-login-form">
            <input
              type="text"
              placeholder="Nhập mã ID"
              value={inputId}
              onChange={handleInputChange}
              required
              className="lgfun-input-id"
              maxLength={15}
            />
            <button type="submit" className="lgfun-submit-btn">
              Đăng Nhập Ngay 🚀
            </button>
          </form>

          {error && <p className="lgfun-error-msg">{error}</p>}
        </div>
      ) : (
        <div className="lgfun-reward-content">
          <div className="lgfun-task-grid">
            {/* Task 1: Điểm danh thường nhật */}
            <div className="lgfun-task-card">
              <div className="lgfun-task-icon">🌟</div>
              <div className="lgfun-task-info">
                <h4>Điểm Danh Nhận Sao</h4>
                <p>Nhận 1 ⭐ mỗi ngày khi ghé thăm</p>
              </div>
              <button
                className="lgfun-action-btn"
                onClick={handleDailyReward}
                disabled={hasDailyToday}
              >
                {hasDailyToday ? 'Đã Nhận ✔️' : 'Nhận 1 ⭐'}
              </button>
            </div>

            {/* Task 3: Thử thách đố vui */}
            <div className="lgfun-task-card">
              <div className="lgfun-task-icon">💡</div>
              <div className="lgfun-task-info">
                <h4>Đố Vui Kinh Thánh</h4>
                <p>Tối đa 3 lượt nhận thưởng/ngày (Thắng tới 15 ⭐)</p>
                <span className="lgfun-attempt-badge">
                  Đã nhận thưởng: {quizAttempts}/3 lượt
                </span>
              </div>
              <button className="lgfun-action-btn quiz" onClick={onGoToQuiz}>
                Vào Thi 🚀
              </button>
            </div>
          </div>

          {quizAttempts < 3 && (
            <div className="lgfun-bonus-banner">
              <p>Bạn còn <b>{3 - quizAttempts}</b> lượt thử thách nhận thưởng đố vui hôm nay!</p>
              <button onClick={onGoToQuiz} className="lgfun-bonus-btn">
                Thử Thách Ngay Nhận +{(3 - quizAttempts) * 5} ⭐
              </button>
            </div>
          )}

          {rewardMessage && <div className="lgfun-success-toast">{rewardMessage}</div>}
        </div>
      )}
    </div>
  );
};

export default DailyReward;